import { Button, makeStyles } from "@material-ui/core"
import { Deck, Edit, HomeWork, Receipt, Settings } from "@material-ui/icons"
import { useEffect } from "react"
import useAppStore from "../../../stores/AppStore"
import BotaoIntegracoes from "../Integracoes/BotaoIntegracoes"
import Segundos from "./Segundos"

const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        justifyContent: "flex-end",
        flex: 2,
        "& > button": {
            color: "#5f5f5f",
        },
        [theme.breakpoints.down("sm")]: {
            "& .small-screen-hidden": {
                display: "none",
            },
            justifyContent: "space-between",
        },
        [theme.breakpoints.down("xs")]: {
            "& .mobile-hidden": {
                display: "none",
            },
            "& button": {
                minWidth: 0,
            },
            "& > button > span > span": {
                margin: 0,
            },
        },
    },
}))

const BotoesUtilitarios = ({
    setExpandListaIntegracoes,
    expandListaIntegracoes,
    resumoDoDia,
    atualizar,
    setRegistradorModal,
    setMesaModal,
    handleBuscarDadosEstabelecimentos,
    setModalConfiguracoes,
    estabelecimentos,
}) => {
    const configuracoes = useAppStore(s => s.configuracoes)
    const tabStatus = useAppStore(s => s.tabStatus)

    const classes = useStyles()

    useEffect(() => {
        handleBuscarDadosEstabelecimentos(false)
    }, [])

    return (
        <div className={classes.container}>
            <BotaoIntegracoes
                setExpandListaIntegracoes={setExpandListaIntegracoes}
                expandListaIntegracoes={expandListaIntegracoes}
            />

            <Button
                onClick={() => {
                    setRegistradorModal(true)
                }}
                startIcon={<Edit />}
            >
                <span className="mobile-hidden">Registrador</span>
            </Button>
            <Button
                onClick={() => {
                    setMesaModal(true)
                }}
                startIcon={<Deck />}
            >
                <span className="mobile-hidden">Mesas</span>
            </Button>

            {estabelecimentos?.length > 1 ? (
                <Button
                    onClick={() => {
                        handleBuscarDadosEstabelecimentos(true)
                    }}
                    startIcon={<HomeWork />}
                >
                    <span className="small-screen-hidden">Estabelecimentos</span>
                </Button>
            ) : (
                <Button
                    onClick={() => {
                        handleBuscarDadosEstabelecimentos(true)
                    }}
                    startIcon={<HomeWork />}
                >
                    <span className="small-screen-hidden">
                        {estabelecimentos[0]?.situacao === 0
                            ? "Fechado"
                            : estabelecimentos[0]?.situacao === 1 && !estabelecimentos[0]?.pausado
                            ? "Aberto"
                            : "Pausado"}
                    </span>
                </Button>
            )}

            {configuracoes?.user?.perfil !== "DELIVERY_BASICO" && (
                <Button onClick={resumoDoDia} startIcon={<Receipt />}>
                    <span className="small-screen-hidden">Resumo</span>
                </Button>
            )}

            <Segundos atualizar={atualizar} />

            <Button onClick={() => setModalConfiguracoes(true)}>
                <Settings />
            </Button>
        </div>
    )
}

export default BotoesUtilitarios
